import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  Box,
  Card,
  CardContent,
  Typography,
  Container,
  Alert,
  Button,
} from '@mui/material'
import { CheckCircle, Error } from '@mui/icons-material'

import axios from 'axios'

const VerifyEmail: React.FC = () => {
  const { token } = useParams<{ token: string }>()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    if (token) {
      verifyEmail(token)
    } else {
      setStatus('error')
      setMessage('Invalid verification link')
    }
  }, [token])

  const verifyEmail = async (verificationToken: string) => {
    try {
      const response = await axios.get(`/auth/verify-email/${verificationToken}`)
      setStatus('success')
      setMessage(response.data.message || 'Email verified successfully!')
    } catch (error: any) {
      setStatus('error')
      setMessage(error.response?.data?.error || 'Email verification failed')
    }
  }

  const handleContinue = () => {
    navigate('/login')
  }

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          py: 4,
        }}
      >
        <Card sx={{ width: '100%', maxWidth: 400 }}>
          <CardContent sx={{ p: 4, textAlign: 'center' }}>
            <Typography variant="h4" component="h1" gutterBottom fontWeight="bold" color="primary">
              TrialFinder
            </Typography>
            
            {status === 'loading' && (
              <Box>
                <Typography variant="h6" gutterBottom>
                  Verifying your email...
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Please wait while we verify your email address.
                </Typography>
              </Box>
            )}

            {status === 'success' && (
              <Box>
                <CheckCircle sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
                <Typography variant="h6" gutterBottom color="success.main">
                  Email Verified!
                </Typography>
                <Alert severity="success" sx={{ mb: 3 }}>
                  {message}
                </Alert>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleContinue}
                  sx={{ mt: 2 }}
                >
                  Continue to Login
                </Button>
              </Box>
            )}

            {status === 'error' && (
              <Box>
                <Error sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
                <Typography variant="h6" gutterBottom color="error.main">
                  Verification Failed
                </Typography>
                <Alert severity="error" sx={{ mb: 3 }}>
                  {message}
                </Alert>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={handleContinue}
                  sx={{ mt: 2 }}
                >
                  Back to Login
                </Button>
              </Box>
            )}
          </CardContent>
        </Card>
      </Box>
    </Container>
  )
}

export default VerifyEmail
